export const firebaseConfig = {
  apiKey: import.meta.env.FIREBASE_API_KEY,
  authDomain:import.meta.env.FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.FIREBASE_PORJECTID,
  storageBucket: import.meta.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.FIREBASE_API_ID,
};

export const FIREBASE_MESSAGING_SW_PATH = "/firebase-messaging-sw.js";

export const FIREBASE_VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY ?? "";
